"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: "fill-primary"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.6,16.19l-1.51-1.38L12.17,14V10.64A1.18,1.18,0,0,0,11,9.46a1.22,1.22,0,0,0-.38.07,1.16,1.16,0,0,0-.81,1.11v3.85a1.18,1.18,0,0,0,.39.87L13,17.94a1.22,1.22,0,0,0,.8.31l.13,0a1.17,1.17,0,0,0,.74-.37A1.19,1.19,0,0,0,15,17,1.17,1.17,0,0,0,14.6,16.19Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.75,3.89,13.9,1.7a1,1,0,0,0,0-1.42,1,1,0,0,0-1.42,0L8.66,4.19a1,1,0,0,0,0,1.4l3.81,3.89a1,1,0,1,0,1.43-1.4L11.75,5.89a8.06,8.06,0,0,1,0,16.11A8,8,0,0,1,3.8,13.94a1,1,0,0,0-2,0A10,10,0,0,0,11.72,24a10.06,10.06,0,0,0,0-20.11Z"
  })));
};

exports["default"] = _default;